import { Box, Dialog, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { formatDate, Icons } from '../../utils/utilities'
import CustomSwitch from '../common/CustomSwitch'
import { ContentCopy } from '@mui/icons-material'
import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

const MeetingDetailsCopyDialog = ( { container, open, setOpen, meeting, handleClose } ) => {

    const [embedDetails, setEmbedDetails] = useState( false )
    const [embedPasskey, setEmbedPasskey] = useState( true )

    const { palette } = useTheme()

    const copyRoomId = useCallback( () => {
        if ( meeting ) {

            let copyText = `${window.location.origin}/${["webinar", "class", "hybrid-class"].includes( meeting.meeting_type ) ? meeting.meeting_type : "meeting"
                }/${meeting.id}`
            if ( embedPasskey )
                copyText += `\nMeeting Passkey: ${meeting.meeting_passkey?.toUpperCase()}`
            if ( embedDetails ) {
                copyText = `${meeting.title}\n${formatDate( meeting.starts_at, { format: "LLL" } )} - ${formatDate( meeting.ends_at, { format: "LLL" } )}\n` + copyText
                if ( !embedPasskey )
                    copyText += `\nMeeting Passkey: ${meeting.meeting_passkey?.toUpperCase()}`
            }

            navigator.clipboard.writeText( copyText )
                .then( () => {
                    toast( embedPasskey ? "Meeting link copied with meeting passkey ." : embedDetails ? "Meeting Details Copied." : 'Meeting link copied.' )
                } )
                .catch( err => {
                    toast( 'Failed to copy: ', err )
                } )
        }
    }, [meeting, embedDetails, embedPasskey] )

    return (
        <Dialog
            slotProps={{
                paper: { sx: { width: "90%", maxWidth: "xs" } }
            }}
            container={container ? container.current : null}
            open={open}
            onClose={() => setOpen( false )}
        >
            <Box padding="20px" display="flex" flexDirection="column" gap="20px" justifyContent="center">
                <Box display="flex" gap="50px" justifyContent="space-between" alignItems="center">
                    <Typography variant="h1" fontWeight="600" component="h3" fontSize="16px">Copy Meeting Details!</Typography>
                    <IconButton size="small" onClick={Boolean( handleClose ) ? handleClose : () => setOpen( false )} >
                        {Icons.default.CloseIcon}
                    </IconButton>
                </Box>

                <Box display="flex" gap="10px">
                    <Box flexGrow={{ md: "initial", xs: "1" }} justifyContent="space-between" display="flex" gap="20px" alignItems="center" padding="5px 10px" borderRadius="20px" bgcolor={palette.primary.main + "33"} border={`2px solid ${palette.primary.main}`} >
                        <Box >
                            <Typography fontSize="12px">
                                Show passkey.
                            </Typography>
                        </Box>
                        <CustomSwitch checked={embedPasskey} onChange={e => setEmbedPasskey( e.target.checked )} />
                    </Box>
                    <Box flexGrow={{ md: "initial", xs: "1" }} justifyContent="space-between" display="flex" gap="20px" alignItems="center" padding="5px 10px" borderRadius="20px" bgcolor={palette.primary.main + "33"} border={`2px solid ${palette.primary.main}`} >
                        <Box >
                            <Typography fontSize="12px">
                                Show more details.
                            </Typography>
                        </Box>
                        <CustomSwitch checked={embedDetails} onChange={e => setEmbedDetails( e.target.checked )} />
                    </Box>
                </Box>

                <Box display="flex" padding="20px" borderRadius="10px" bgcolor={palette.borderColor + "22"} border={`2px solid ${palette.borderColor}`} gap="20px" alignItems="flex-end" justifyContent="space-between">
                    <Box width="100%" overflow="hidden" >
                        {embedDetails && <Typography fontWeight={500} fontSize="16px" display="block" component="em">{meeting.title}</Typography>}
                        {embedDetails && <Typography fontWeight={300} fontSize="14px" display="block" component="em">{`${formatDate( meeting.starts_at, { format: "LLL" } )} - ${formatDate( meeting.ends_at, { format: "LLL" } )}`}</Typography>}
                        <Typography marginTop={embedDetails ? "20px" : ""} noWrap fontSize="14px" display="block" component="em">{`${window.location.origin}/${["webinar", "class", "hybrid-class"].includes( meeting.meeting_type ) ? meeting.meeting_type : "meeting"}/${meeting.id}`}</Typography>
                        <Typography display="block" fontSize="12px" component="strong">Passkey: {!embedPasskey ? "XXXXXXXX" : meeting.meeting_passkey?.toUpperCase()}</Typography>
                    </Box>
                    <Tooltip disableInteractive placement='top' title="Copy Meeting Link with Passkey">
                        <IconButton size="small" onClick={() => copyRoomId( embedPasskey, embedDetails )} >
                            <ContentCopy />
                        </IconButton>
                    </Tooltip>
                    {/* <Tooltip disableInteractive placement='top' title="Copy Meeting Link">
                        <IconButton size="small" onClick={() => copyRoomId( false )} >
                            <CopyAll />
                        </IconButton>
                    </Tooltip> */}
                </Box>
                {/* <Box display="flex" gap="10px" alignItems="center">
                    <Button size="small" color='secondary' variant='outlined' onClick={() => setOpen( false )}>Okay</Button>
                    <Button size="small" color='secondary' variant='outlined' onClick={() => copyRoomId( false, true )}>Copy Room Details</Button>
                </Box> */}
            </Box>
        </Dialog>
    )
}

export default MeetingDetailsCopyDialog